import React from 'react';

import { Icon } from '@/components/core/';

import styles from './CalendarPopup.module.scss';

type CalendarPopupProps = {
    url: string | undefined;
};

export const CalendarPopup: React.FC<CalendarPopupProps> = ({ url }) => {
    if (!url) return null;
    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>
                <div className={styles.iconWrapper}>
                    <Icon
                        className={styles.icon}
                        name="close"
                        func="goBack"
                    />
                </div>
                <iframe
                    src={url}
                    style={{ border: 0 }}
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
    );
};
